module.exports = __webpack_public_path__ + "img/banner.dfcf3f49.jpg";